module.exports = __webpack_public_path__ + "img/sardinia.3c1a7a5c.png";